export interface ILanguageInfo {
  name: string;
  nativeName: string;
  flag: string;
  countryCode: string;
  speakers: number;
}

export const ALL_LANGUAGES: Record<string, ILanguageInfo> = {
  zh: {
    name: 'Mandarin Chinese',
    nativeName: '中文',
    flag: '🇨🇳',
    countryCode: 'CN',
    speakers: 1100,
  },
  hi: { name: 'Hindi', nativeName: 'हिन्दी', flag: '🇮🇳', countryCode: 'IN', speakers: 600 },
  es: { name: 'Spanish', nativeName: 'Español', flag: '🇪🇸', countryCode: 'ES', speakers: 560 },
  fr: { name: 'French', nativeName: 'Français', flag: '🇫🇷', countryCode: 'FR', speakers: 310 },
  ar: { name: 'Arabic', nativeName: 'العربية', flag: '🇸🇦', countryCode: 'SA', speakers: 310 },
  bn: { name: 'Bengali', nativeName: 'বাংলা', flag: '🇧🇩', countryCode: 'BD', speakers: 270 },
  pt: { name: 'Portuguese', nativeName: 'Português', flag: '🇧🇷', countryCode: 'BR', speakers: 260 },
  ru: { name: 'Russian', nativeName: 'Русский', flag: '🇷🇺', countryCode: 'RU', speakers: 250 },
  ur: { name: 'Urdu', nativeName: 'اردو', flag: '🇵🇰', countryCode: 'PK', speakers: 230 },
  id: {
    name: 'Indonesian',
    nativeName: 'Bahasa Indonesia',
    flag: '🇮🇩',
    countryCode: 'ID',
    speakers: 200,
  },
  de: { name: 'German', nativeName: 'Deutsch', flag: '🇩🇪', countryCode: 'DE', speakers: 135 },
  ja: { name: 'Japanese', nativeName: '日本語', flag: '🇯🇵', countryCode: 'JP', speakers: 125 },
  tl: { name: 'Filipino', nativeName: 'Filipino', flag: '🇵🇭', countryCode: 'PH', speakers: 115 },
  sw: { name: 'Swahili', nativeName: 'Kiswahili', flag: '🇰🇪', countryCode: 'KE', speakers: 100 },
  mr: { name: 'Marathi', nativeName: 'मराठी', flag: '🇮🇳', countryCode: 'IN', speakers: 99 },
  te: { name: 'Telugu', nativeName: 'తెలుగు', flag: '🇮🇳', countryCode: 'IN', speakers: 96 },
  tr: { name: 'Turkish', nativeName: 'Türkçe', flag: '🇹🇷', countryCode: 'TR', speakers: 90 },
  ta: { name: 'Tamil', nativeName: 'தமிழ்', flag: '🇮🇳', countryCode: 'IN', speakers: 87 },
  vi: { name: 'Vietnamese', nativeName: 'Tiếng Việt', flag: '🇻🇳', countryCode: 'VN', speakers: 85 },
  ko: { name: 'Korean', nativeName: '한국어', flag: '🇰🇷', countryCode: 'KR', speakers: 82 },
  fa: { name: 'Persian', nativeName: 'پارسی', flag: '🇮🇷', countryCode: 'IR', speakers: 80 },
  it: { name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹', countryCode: 'IT', speakers: 68 },
  gu: { name: 'Gujarati', nativeName: 'ગુજરાતી', flag: '🇮🇳', countryCode: 'IN', speakers: 62 },
  th: { name: 'Thai', nativeName: 'ไทย', flag: '🇹🇭', countryCode: 'TH', speakers: 61 },
  pa: { name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', flag: '🇮🇳', countryCode: 'IN', speakers: 57 },
  kn: { name: 'Kannada', nativeName: 'ಕನ್ನಡ', flag: '🇮🇳', countryCode: 'IN', speakers: 56 },
  my: { name: 'Burmese', nativeName: 'မြန်မာ', flag: '🇲🇲', countryCode: 'MM', speakers: 43 },
  pl: { name: 'Polish', nativeName: 'Polski', flag: '🇵🇱', countryCode: 'PL', speakers: 41 },
  ml: { name: 'Malayalam', nativeName: 'മലയാളം', flag: '🇮🇳', countryCode: 'IN', speakers: 38 },
  uk: { name: 'Ukrainian', nativeName: 'Українська', flag: '🇺🇦', countryCode: 'UA', speakers: 35 },
  uz: { name: 'Uzbek', nativeName: 'Oʻzbek', flag: '🇺🇿', countryCode: 'UZ', speakers: 35 },
  ms: { name: 'Malay', nativeName: 'Bahasa Melayu', flag: '🇲🇾', countryCode: 'MY', speakers: 33 },
  am: { name: 'Amharic', nativeName: 'አማርኛ', flag: '🇪🇹', countryCode: 'ET', speakers: 32 },
  ne: { name: 'Nepali', nativeName: 'नेपाली', flag: '🇳🇵', countryCode: 'NP', speakers: 32 },
  nl: { name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱', countryCode: 'NL', speakers: 30 },
  ro: { name: 'Romanian', nativeName: 'Română', flag: '🇷🇴', countryCode: 'RO', speakers: 26 },
  km: { name: 'Khmer', nativeName: 'ខ្មែរ', flag: '🇰🇭', countryCode: 'KH', speakers: 18 },
  si: { name: 'Sinhala', nativeName: 'සිංහල', flag: '🇱🇰', countryCode: 'LK', speakers: 17 },
  kk: { name: 'Kazakh', nativeName: 'Қазақ', flag: '🇰🇿', countryCode: 'KZ', speakers: 16 },
  el: { name: 'Greek', nativeName: 'Ελληνικά', flag: '🇬🇷', countryCode: 'GR', speakers: 13 },
  hu: { name: 'Hungarian', nativeName: 'Magyar', flag: '🇭🇺', countryCode: 'HU', speakers: 13 },
  cs: { name: 'Czech', nativeName: 'Čeština', flag: '🇨🇿', countryCode: 'CZ', speakers: 11 },
  sv: { name: 'Swedish', nativeName: 'Svenska', flag: '🇸🇪', countryCode: 'SE', speakers: 10 },
  az: {
    name: 'Azerbaijani',
    nativeName: 'Azərbaycan',
    flag: '🇦🇿',
    countryCode: 'AZ',
    speakers: 10,
  },
  he: { name: 'Hebrew', nativeName: 'עברית', flag: '🇮🇱', countryCode: 'IL', speakers: 9 },
  sr: { name: 'Serbian', nativeName: 'Српски', flag: '🇷🇸', countryCode: 'RS', speakers: 9 },
  bg: { name: 'Bulgarian', nativeName: 'Български', flag: '🇧🇬', countryCode: 'BG', speakers: 8 },
  da: { name: 'Danish', nativeName: 'Dansk', flag: '🇩🇰', countryCode: 'DK', speakers: 6 },
  fi: { name: 'Finnish', nativeName: 'Suomi', flag: '🇫🇮', countryCode: 'FI', speakers: 6 },
  no: { name: 'Norwegian', nativeName: 'Norsk', flag: '🇳🇴', countryCode: 'NO', speakers: 5 },
  sk: { name: 'Slovak', nativeName: 'Slovenčina', flag: '🇸🇰', countryCode: 'SK', speakers: 5 },
  hr: { name: 'Croatian', nativeName: 'Hrvatski', flag: '🇭🇷', countryCode: 'HR', speakers: 5 },
  ka: { name: 'Georgian', nativeName: 'ქართული', flag: '🇬🇪', countryCode: 'GE', speakers: 4 },
  ca: { name: 'Catalan', nativeName: 'Català', flag: '🇪🇸', countryCode: 'ES', speakers: 4 },
  lt: { name: 'Lithuanian', nativeName: 'Lietuvių', flag: '🇱🇹', countryCode: 'LT', speakers: 3 },
  lv: { name: 'Latvian', nativeName: 'Latviešu', flag: '🇱🇻', countryCode: 'LV', speakers: 2 },
  et: { name: 'Estonian', nativeName: 'Eesti', flag: '🇪🇪', countryCode: 'EE', speakers: 1 },
};
